import * as R from 'ramda';
export const stringOr = R.curry((defaultValue, value) => R.o(R.unless(R.is(String), R.toString), R.defaultTo(defaultValue))(value));
